module.exports = __webpack_public_path__ + "img/scene-individual.f44154a2.svg";